import { Component, Input, } from '@angular/core';
import { TransportCount, TransportCounts } from '../../../../../common/model/transport.model';



@Component({
  selector: 'app-transport-counts',
  templateUrl: './transport-counts.component.html',
  styleUrls: ['./transport-counts.component.scss'],
  standalone: false
})
export class TransportCountsComponent {

  counts: Array<TransportCount>;

  total = 0;

  @Input('counts') set setTransportCounts(value: Array<TransportCount>) {
    this.counts = value;
    let total = 0;
    for (const count of value) {
      total += count.count;
    }
    this.total = total;
  }

  constructor() { }

}
